import React, {useEffect, useState} from 'react';
import shell from './miniapp-shell.module.css';
import Vpn from "./vpn/vpn";
import Info from "./info/info";
import {useTelegram} from "../../../hooks/useTelegram";
import {getClientAPI, startClientAPI} from "./api";
import Menu from "./menu/menu";
import Friends from "./friends/friends";
import Challenge from "./challenge/challenge";

const MiniApp = () => {
    const [page, setPage] = useState(0)
    const {webApp} = useTelegram()
    const [client, setClient] = useState({})
    const [getStartParams, setGetStartParams] = useState(true)
    const [openAddBalance, setOpenAddBalance] = useState(false)

    async function getClient(){
        const res = await getClientAPI()
        setClient(res)
    }


    useEffect(()=>{
        if(webApp.platform !== 'unknown') {
            webApp.ready()
            webApp.expand()
            startClientAPI()
        }
        getClient()
    },[])


    useEffect(()=>{
        const hash = window.location.hash.slice(1);
        const params = new URLSearchParams(hash);
        const tgWebAppData = new URLSearchParams(params.get('tgWebAppData'));
        const startParamsT = tgWebAppData.get('start_param');
        console.log(startParamsT)
        if(startParamsT && getStartParams){
            if(startParamsT.split('=')[0] === 'page'){
                if(startParamsT.split('=')[1] === 'info'){
                    setPage(1)
                }
                if(startParamsT.split('=')[1] === 'friends'){
                    setPage(2)
                }
                if(startParamsT.split('=')[1] === 'payment'){
                    setOpenAddBalance(true)
                }
                //if(startParamsT.split('=')[1] === 'challenge'){
                //    setPage(3)
                //}
            }
            setGetStartParams(false)
        }
    },[])


    return (
        <div className={shell.shell}>
            {page === 0 && <Vpn client={client} getClient={getClient} openAddBalance={openAddBalance} setOpenAddBalance={setOpenAddBalance}/>}
            {page === 1 && <Info/>}
            {page === 2 && <Friends client={client} getClient={getClient}/>}
            {page === 3 && <Challenge client={client} getClient={getClient}/>}
            <Menu page={page} setPage={setPage}/>
        </div>
    )
};

export default MiniApp;